import React, { useContext, useState } from 'react';
import { ChevronDown } from 'lucide-react';
import { clearStoredUserData } from '@/hooks/use-onboarding-tour';
import { Menu } from 'lucide-react';
import { AuthContext } from '../auth-context/auth-context';
import routeConfig from '../../config/routeConfig';
import cssConfig from '../../config/cssConfig';
import { Link, useHistory, useLocation } from 'react-router-dom';
import styles from './header.module.css';
import headerLogo from '../../images/logo_cybersign--black.svg';
import { User } from 'lucide-react';
import LogoutButton from '../logout-button/LogoutButton';
import { useSidebar } from '../../provider/sidebar/sidebar-context';

interface HeaderSidenavProps {
	userName: string;
	userEmail: string;
}

const HeaderSidenav: React.FC<HeaderSidenavProps> = ({
	userName,
	userEmail,
}) => {
	const location = useLocation();
	const [userDropDown, setUserDropDown] = useState(false);
	const history = useHistory();
	const { showSidebar, hideSidebar, isHidden } = useSidebar();

	window!.onscroll = function () {
		cssConfig.handleHeaderSidenav();
	};

	/**
	 * Toggles the sidebar visibility state.
	 * If the sidebar is hidden, it will open, otherwise it will close.
	 */
	const toggleSidebar = () => {
		if (isHidden) {
			showSidebar();
		} else {
			hideSidebar();
		}
	};

	const dropdownTrigger = () => {
		if (userDropDown === false) {
			document
				.querySelector('.cyber-user-dropdown__list')!
				.classList.add('visible');
			setUserDropDown(true);
		} else {
			document
				.querySelector('.cyber-user-dropdown__list')!
				.classList.remove('visible');
			setUserDropDown(false);
		}
	};

	const toProfile = () => {
		document
			.querySelector('.cyber-user-dropdown__list')!
			.classList.remove('visible');
		setUserDropDown(false);
		history.push(routeConfig.profile);
	};

	const expDate = JSON.parse(localStorage.getItem('token-expir-date')!);

	// arreglar let tokenED = Number(tokenExpirDateC.tokenExpirDate)

	const currentDate = new Date().getTime() / 1000;

	if (expDate != null) {
		if (currentDate > expDate) {
			clearStoredUserData();
			history.push('/');
			history.go(0);
		}
	}

	const authCtx = useContext(AuthContext);
	if (location.pathname.match(routeConfig.requestSignature)) {
		return null;
	} else {
		return (
			<div id="header" className="cyber-header with-sidenav">
				<div
					className="cyber-container flex space-between"
					style={{ maxWidth: 'none' }}
				>
					<div className="cyber-header__column-left">
						<Link
							to="#"
							className="cyber-sidenav__trigger"
							onClick={toggleSidebar}
						>
							<Menu />
						</Link>
					</div>
					<div className="cyber-header__column-center">
						<Link to={routeConfig.home}>
							<img
								className="cyber-header__logo"
								src={headerLogo}
								alt=""
							/>
						</Link>
					</div>

					{authCtx.isAuthenticated ? (
						<div className="cyber-header__column-right">
							<div className="cyber-user-dropdown">
								<button
									className="cyber-user-dropdown__trigger"
									onClick={dropdownTrigger}
								>
									<div className="cyber-user-dropdown__user-info">
										<span className={styles['user-name']}>
											{userName
												.toLowerCase()
												.replace(',', '')}
										</span>
										<span className="cyber-user-dropdown__email">
											{userEmail}
										</span>
									</div>
									<div className="cyber-user-dropdown__arrow">
										<ChevronDown />
									</div>
								</button>
								<div className="cyber-user-dropdown__list">
									<Link
										to="#"
										className="cyber-user-dropdown__item"
										onClick={toProfile}
									>
										<div className="cyber-user-dropdown__item-icon">
											<User />
										</div>
										Perfil
									</Link>
									<LogoutButton />
								</div>
							</div>
						</div>
					) : null}
				</div>
			</div>
		);
	}
};

export default HeaderSidenav;
